import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-arrow-left",
  "use": "default-arrow-left-usage",
  "viewBox": "0 0 10 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 15\" id=\"default-arrow-left\"><path d=\"M7.293.293L1.486 6.097a.998.998 0 00-.84 1.128.999.999 0 00.841 1.128l5.806 5.804a1 1 0 001.414-1.414L3.19 7.225l5.517-5.518A1 1 0 107.293.293z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol